/* eslint-disable max-classes-per-file */
import {
    AfterViewInit,
    Directive,
    Input,
    OnDestroy,
    OnInit,
    inject
} from "@angular/core";
import moment from "moment";
import { BehaviorSubject } from "rxjs";
import { WebinstallningarService } from "~app/common/services/webinstallningar/webinstallningar.service";
import { InputComponent } from "../../components/input/input.component";
import { SelectorComponent } from "../../components/selector/selector.component";
import { Webinstallning, WebinstallningGroup } from "./webinstallning.model";

@Directive({ selector: "[raskWebinstallning]" })
export class WebinstallningDirective implements OnInit, OnDestroy, AfterViewInit {
    selectorComponent = inject(SelectorComponent, {
        host: true,
        self: true,
        optional: true
    });
    inputComponent = inject(InputComponent, {
        host: true,
        self: true,
        optional: true
    });

    @Input() raskWebinstallning: string;

    private readonly webinstallningService = inject(WebinstallningarService);
    private behaviour: any;
    private group: WebinstallningGroup;

    ngOnInit(): void {
        if (this.selectorComponent) {
            this.behaviour = new SelectorBehaviour(this.selectorComponent);
        } else if (this.inputComponent) {
            this.behaviour = new InputBehaviour(this.inputComponent);
        }
    }

    ngAfterViewInit(): void {
        this.initInstallning();
    }

    ngOnDestroy(): void {
        this.saveInstallning();
    }

    initInstallning() {
        this.webinstallningService.getAsync<WebinstallningGroup>(this.raskWebinstallning)
            .then(x => {
                this.group = x;
                if (this.group == null) {
                    this.group = { installningar: [] };
                }
                this.behaviour.setList(this.group);
            });
    }

    saveInstallning(): void {
        const existingNames = this.group.installningar.map(y => y.name.toLowerCase());
        const list = this.behaviour.getList().filter(x => existingNames.indexOf(x.toLowerCase()) === -1);
        const wilist = list.map(x => ({ name: x,
            date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss") })).concat(this.group.installningar) as Webinstallning[];
        this.webinstallningService.set<WebinstallningGroup>(this.raskWebinstallning, { installningar: wilist });
    }
}

class SelectorBehaviour {
    constructor(private readonly component: SelectorComponent) {
        this.component.values = new BehaviorSubject<any>(null);
    }
    getList() {
        return this.component.values.value;
    }
    setList(group: WebinstallningGroup) {
        this.component.values.next(this.extractValues(group));
    }

    extractValues(group) {
        return group && group.installningar ? group.installningar.map(x => x.name) : [];
    }
}

class InputBehaviour {
    constructor(private readonly component: InputComponent) { }
    getList() { return [this.component.value]; }
    setList(group: WebinstallningGroup) { this.component.value = group.installningar[0]; }
}
